/**
 * Fime – "Download product sheet" form (Gravity Forms ID 1), used by
 * BOTH the Key Benefits panel and the Overview (single-env-cta)
 * panel — the same Gravity Form is embedded twice on templates that
 * have both sections, so this scopes everything per-panel instead
 * of relying on Gravity Forms' hardcoded field/button IDs (which get
 * suffixed on the second instance, e.g. input_1_3_2).
 *
 * 1. Sets each panel's Topic field placeholder to that panel's own
 *    data-topic-default, instead of the hardcoded GF default.
 *
 * 2. Since submitting this form redirects to a file-download URL
 *    (not a normal page), the browser never "navigates away" and
 *    Gravity Forms' own JS never sees that as a completed
 *    submission — its loading spinner stays stuck on the submit
 *    button indefinitely. This clears it manually per-panel once a
 *    spinner/disabled submit button appears inside it.
 */

document.querySelectorAll('.download-form-panel[data-topic-default]').forEach(function (panel) {
        const defaultTopic = panel.dataset.topicDefault;
        if (!defaultTopic) return;

        const topicField = panel.querySelector('input[name="input_3"]');
        if (topicField) {
                topicField.setAttribute('placeholder', defaultTopic);
        }
});

// Optional per-panel override for the "Your request" field (input_1) —
// only set where a panel explicitly provides data-request-default (e.g.
// the Overview/single-env-cta panel). Panels without it (Key Benefits)
// keep Gravity Forms' own default placeholder untouched.
document.querySelectorAll('.download-form-panel[data-request-default]').forEach(function (panel) {
        const defaultRequest = panel.dataset.requestDefault;
        if (!defaultRequest) return;

        const requestField = panel.querySelector('input[name="input_1"]');
        if (requestField) {
                requestField.setAttribute('placeholder', defaultRequest);
        }
});

const spinnerObserver = new MutationObserver(function () {
        document.querySelectorAll('.download-form-panel').forEach(function (panel) {
                const spinner = panel.querySelector('[id^="gform_ajax_spinner_1"]');
                if (spinner) {
                        spinner.remove();
                }

                const btn = panel.querySelector('[id^="gform_submit_button_1"]');
                if (btn) {
                        btn.removeAttribute('disabled');
                }
        });
});

spinnerObserver.observe(document.body, { childList: true, subtree: true });
